import { Link,useLocation } from 'react-router-dom'
import './BottomNavigationBar.css'

const BottomNavigationBar = () => {

    const location = useLocation()

    return (
        <div id="bottom-navigation-bar">
            <Link to="/app" className={location.pathname === '/app' ? 'active' : ''}>
                <i className="fal fa-home"></i>
                <span>خانه</span>
            </Link>
            <Link to="/app/orders" className={location.pathname === '/app/orders' ? 'active' : ''}>
                <i className="fal fa-basket-shopping"></i>
                <span>سفارشات</span>
            </Link>
            <Link to="/app/payment" className={location.pathname === '/app/payment' ? 'active' : ''}>
                <i className="fal fa-credit-card"></i>
                <span>پرداخت</span>
            </Link>
            <Link to="/app/settings" className={location.pathname === '/app/settings' ? 'active' : ''}>
                <i className="fal fa-gear"></i>
                <span>تنظیمات</span>
            </Link>
        </div>
    )
}

export default BottomNavigationBar